import * as R from "ramda";
import React, { Component } from "react";

import { Datagrid, TextField, ReferenceField } from "react-admin";

import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import { PatientReferenceField } from "../../misc/customFields";

const styles = {
  container: { minWidth: "35em", marginLeft: "1em" },
  rightAlignedCell: { textAlign: "center" },
  boldCell: { fontWeight: "bold" }
};

class PatientsAside extends Component {
  render() {
    const { classes, record } = this.props;
    if (!record) return null;
    let { patients } = record;
    if (R.isEmpty(patients) || R.isNil(patients)) return null;
    const ids = patients.map(p => p.id);
    patients = patients.reduce((acc, p) => {
      acc[p.id] = p;
      return acc;
    }, {});

    return (
      <Paper className={classes.container}>
        <div>
          <Typography variant="h4" className={classes.rightAlignedCell}>
            Patients
          </Typography>
        </div>
        <Datagrid
          ids={ids}
          resource="patients"
          data={patients}
          basePath="/patients"
          currentSort={{ field: "id", order: "DESC" }}
        >
          <PatientReferenceField/>
          <TextField source="email" />
          <TextField source="gender" />
        </Datagrid>
      </Paper>
    );
  }
}

export default withStyles(styles)(PatientsAside);
